import { render, staticRenderFns } from "./settingsPanel.vue?vue&type=template&id=0c667ccb&"
import script from "./settingsPanel.vue?vue&type=script&lang=js&"
export * from "./settingsPanel.vue?vue&type=script&lang=js&"
import style0 from "./settingsPanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports